/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
const  ready = (callback) => {
	if (document.readyState != "loading") callback();
	else document.addEventListener("DOMContentLoaded", callback);
};

ready(()=>{
	document.querySelectorAll('.wp-block-spielzeugmuseum-blocks-burger').forEach((item)=>{
		item.classList.add('closed');

		item.addEventListener('click', (event)=> {
			if(item.classList.contains('closed')) {
				item.classList.remove('closed');
				item.classList.add('open');
			} else {
				item.classList.add('closed');
				item.classList.remove('open');
			}
		});
	});
});
/* eslint-enable no-console */
